import { useRef } from "react";
import { LogoImageReplaceIcon } from "../../../assets/icons/iconsProvider";
import LogoImage from "../../../assets/images/Rectangle31.png";
import { storeConstants } from "../../../constants";
import { handleUploadProductImage } from "../../utility";

const InputImageField = (props) => {
  const { imgUrl, setImgUrl = () => {} } = props;
  const hiddenFileInput = useRef(null);

  //-------Change Logo image button
  const handleReplaceButtonClick = () => {
    hiddenFileInput.current.click();
  };
  const handleImageChange = (e) => {
    handleUploadProductImage(
      e,
      () => {},
      () => {},
      {},
      (data) => {
        setImgUrl(data.imgUrl);
      },
      {
        isResize: true,
        newWidth: storeConstants.RECEIPT_IMAGE_RESIZE_WIDTH,
      }
    );
  };

  return (
    <div className="receipt-logo-image-wrapper">
      <img
        src={imgUrl || LogoImage}
        alt="logo"
        className="receipt-logo-image"
      />
      <input
        type="file"
        className="d-none"
        accept=".png, .jpg, .jpeg"
        onChange={handleImageChange}
        ref={hiddenFileInput}
      />
      <button
        onClick={handleReplaceButtonClick}
        type="button"
        className="replace-logo-button"
      >
        <LogoImageReplaceIcon className="replace-icon" />
      </button>
    </div>
  );
};

export default InputImageField;
